const model = {
  number: {
    name: "№ з/б",
    sex: 1,
    required: true,
    checkLength: true,
    min: 1,
    max: 5,
    isNumber: true,
    isNumberInteger: true
  },
  date_created: {
    name: "Первая операция",
    sex: 2,
    required: true,
    checkLength: true,
    min: 10,
    max: 10,
    isNumber: false
  },
  date_return: {
    name: "Дата возврата",
    sex: 2,
    required: true,
    checkLength: true,
    min: 10,
    max: 10,
    isNumber: false
  },
  days: {
    name: "Всего дней",
    sex: 1,
    required: true,
    checkLength: false,
    isNumber: true,
    isInteger: true
  },
  days_new: {
    name: "Продлён на",
    sex: 1,
    required: true,
    checkLength: false,
    isNumber: false
  },
  sum_items: {
    name: "сумма оценки",
    sex: 2,
    required: true,
    checkLength: false,
    isNumber: true
  },
  sum_give: {
    name: "сумма выдачи",
    sex: 2,
    required: true,
    checkLength: false,
    isNumber: true
  },
  percent: {
    name: "используемый процент",
    sex: 2,
    required: true,
    checkLength: false,
    isNumber: true
  },
  sum_percent: {
    name: "сумма процентов",
    sex: 2,
    required: true,
    checkLength: false,
    isNumber: true
  },
  sum_return: {
    name: "сумма возврата",
    sex: 2,
    required: true,
    checkLength: false,
    isNumber: true
  },
  comment: {
    name: "комментарий",
    sex: 1,
    required: false,
    checkLength: false
  },
  created_at: {
    name: "Дата создания",
    sex: 2,
    required: true,
    checkLength: true,
    min: 10,
    max: 10,
    isNumber: false
  },
  updated_at: {
    name: "Дата обновления",
    sex: 2,
    required: true,
    checkLength: true,
    min: 10,
    max: 10,
    isNumber: false
  },
  fines: {
    type_fyne: {
      name: "Тип штрафа",
      sex: 1,
      required: true,
      checkLength: false
    },
    days_fine: {
      name: "Кол-во дней штрафа",
      sex: 0,
      required: true,
      checkLength: false,
      isNumber: true,
      isInteger: true
    },
    percent_fine: {
      name: "Процент штрафа",
      sex: 1,
      required: true,
      checkLength: false,
      isNumber: true
    },
    sum_fine: {
      name: "Сумма штрафа",
      sex: 2,
      required: true,
      checkLength: false,
      isNumber: true,
      isNumberPositive: true
    },
    created_at: {
      name: "Дата создания",
      sex: 2,
      required: true,
      checkLength: true,
      min: 10,
      max: 10
    },
    updated_at: {
      name: "Дата обновления",
      sex: 2,
      required: true,
      checkLength: true,
      min: 10,
      max: 10
    },
    historyId: {
      name: "Дата операции",
      sex: 2,
      required: true,
      checkLength: false
    }
  },
  history: {
    sum: {
      name: "сумма",
      sex: 2,
      required: true,
      checkLength: false,
      isNumber: true
    }
  },
  depositor: {
    iin: {
      name: "ИИН залогодателя",
      sex: 1,
      required: true,
      checkLength: true,
      min: 9,
      max: 12,
      isNumber: true,
      isNumberInteger: true
    }
  },
  filial: {
    name: "Филиал",
    sex: 1,
    required: false,
    checkLength: false
  }
};

module.exports = model;
